import { gql, useQuery } from '@apollo/client';
import {
  Box,
  HStack,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@chakra-ui/layout';
import NextLink from 'next/link';
import * as React from 'react';

import { OrganizationProfileImage } from '@/components/OrganizationProfileImage';
import { Card } from '@/imports/ui/chakra/components/Card';

import { FeaturedSponsor_GetFeaturedSponsor } from './graphql-types/FeaturedSponsor_GetFeaturedSponsor';

import { FeaturedSponsorButton } from './components/FeaturedSponsorButton';

const GET_FEATURED_SPONSOR = gql`
  query FeaturedSponsor_GetFeaturedSponsor {
    getFeaturedSponsor {
      result {
        _id
        name
        ...OrganizationProfileImage_OrganizationFragment
        ...FeaturedSponsorButton_SponsorFragment
      }
    }
  }
  ${FeaturedSponsorButton.sponsorFragment}
  ${OrganizationProfileImage.organizationFragment}
`;

export const FeaturedSponsor: React.FC = () => {
  const query =
    useQuery<FeaturedSponsor_GetFeaturedSponsor>(GET_FEATURED_SPONSOR);

  const featuredSponsor = query.data?.getFeaturedSponsor.result;

  if (!featuredSponsor) {
    return null;
  }

  return (
    <Card width="full">
      <Stack spacing="2" p="4" w="full">
        <Text w="full" color="gray.600" textStyle="compactStrong" px="2">
          FEATURED SPONSOR
        </Text>
        <LinkBox w="full" p="2" _hover={{ bg: 'gray.100' }} borderRadius="xl">
          <HStack spacing="2" alignItems="center" w="full">
            <OrganizationProfileImage
              h={20}
              w={20}
              organization={featuredSponsor}
            />
            <Box flex="1" minWidth="0">
              <LinkOverlay
                as={NextLink}
                href={`/companies/${featuredSponsor._id}`}
              >
                <Text textStyle="xlBodyStrong" noOfLines={2}>
                  {featuredSponsor.name}
                </Text>
              </LinkOverlay>
            </Box>
          </HStack>
        </LinkBox>
        <FeaturedSponsorButton featuredSponsor={featuredSponsor} />
      </Stack>
    </Card>
  );
};
